module.exports = __webpack_public_path__ + "static/media/select_device.dfeb6309.png";